import React from 'react'

const FormatDownload = ({ url }) => {
    return (
        <div className="mb-3">
            <a href={url} > <i className="bx bx-import"></i>Download Format File</a>
        </div>
    )
}

export default FormatDownload
